import { Spin } from "antd";
import React, { Suspense } from "react";
import { AuthenticationWrap } from "./style";

const CaseRspLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <AuthenticationWrap>
          <div className="headerCase">
            <img src={require(`../../../static/img/brand-logo-wh.jpg`)} alt="" /> 
          </div>
          <div className="ninjadash-authentication-wrap">
            <WraperContent />
          </div>
        </AuthenticationWrap>
      </Suspense>
    );
  };
};

export default CaseRspLayout;
